import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-end mt-8"
}
const _hoisted_2 = { class: "version-style" }

import { onMounted, ref } from 'vue';
import { OrganismsBar } from '@/components/organisms';
import { AtomPreloader } from '@/components/atoms';
import { Authentication } from '@/store';
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();

const version = ref('');
onMounted(async () => {
  Authentication.actions.ActionCheckToken();

  fetch('/version')
    .then((response) => response.text())
    .then((csvString) => {
      version.value = csvString;
    });
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_app, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_main, null, {
          default: _withCtx(() => [
            (_unref(Authentication).getters.getStatusLoggedIn.value && _ctx.$route.name !== 'NotFound')
              ? (_openBlock(), _createBlock(_unref(OrganismsBar), { key: 0 }))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass([[_unref(Authentication).getters.getStatusLoggedIn.value ? 'area-content' : ''], "mt-0 h-100"])
            }, [
              _createVNode(_component_router_view),
              (_unref(Authentication).getters.getStatusLoggedIn.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("p", _hoisted_2, "Versão " + _toDisplayString(version.value) + " © Go Ahead, todos os direitos reservados.", 1)
                  ]))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(AtomPreloader))
  ], 64))
}
}

})